module.exports = __webpack_public_path__ + "static/media/react native complete guide.4217ba30.pdf";